import React, { useState } from "react";
import "antd/dist/antd.min.css";
import PageWrapper from "../../helpers/PageWrapper";
import { Input, Form,  message, Space, Button, Typography, DatePicker, Select  } from "antd";
import moment from "moment";
import TokenService from "../../../services/token.service";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import authAxios from "../../../services/api";

const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const LessonCreatePage = () => {
  const { teacherId, streamId } = useParams();
  const [theme, setTheme] = useState('');
  const [desc, setDesc] = useState('');
  const [studyHours, setStudyHours] = useState();
  const [date, setDate] = useState(new Date());
  const navigate = useNavigate();
  const { Option } = Select;
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     date: new Date(),
  //     theme: '',
  //     desc: '',
  //   }
  // }
 
  const onDateChange = (date, dateString) => {
   
      setDate(dateString)
    
  };


  const onThemeChange = event => {
    
      setTheme(event.target.value)
  
  };
  const onDescChange = event => {
    
      setDesc(event.target.value)
      
  };
  const onStudyHoursChange = (StudyHour) => {
    
    setStudyHours(StudyHour)
    console.log(StudyHour)
};
  let hour = 2 
  if (teacherId == 25 || teacherId == 24 || teacherId == 26) {
      hour = studyHours
  }



  const handleSubmit = () => {
    const lesson = {
      hour: hour,
      date: date,
      theme: theme,
      desc: desc,
    };
    console.log(lesson)


    
    authAxios.post(`http://85.159.27.198:8080/abitur/api/v1/teacher/${teacherId}/streams/${streamId}/lessons/create`, lesson, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    })
      .then(res => {
        console.log(res);
        console.log(res.data);
        message.success('Новый урок добавлен', 10);
      })
      .catch((error) =>  message.error(error, 10));
      // navigate(`/lesson-plan-page/teacherId/${teacherId}/stream-id/${streamId}`);
      // window.location.reload();
      
  }
  let studyHour;
  if (teacherId == 25 || teacherId == 24 || teacherId == 26) {
        studyHour =   <Form.Item
          label="Количество учебных часов"
          name="studyHours"
          value={studyHours}
          // onChange={onStudyHoursChange}
          rules={[{ required: true, message: 'Введите количество учебных часов' }]}
        >
          <Select  style={{ width: '50%' }} onSelect={(value) => onStudyHoursChange(value)}>
        <Option value="2">2</Option>
        <Option value="6">6</Option>
      </Select>
        </Form.Item>
          
          }
    
    // const { date, theme, desc } = this.state

    return (
      <PageWrapper>
        {/* <BackButton onClick = {history.goBack} /> */}
        <Typography.Title level={1}>Создание урока</Typography.Title>
        <Form
          layout="vertical"
          size="large"
          style={styles}
          // initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Дата занятия"
            name="date"
            value={date}
            rules={[{ required: true, message: "Выберите дату" }]}
          >
            <DatePicker onChange={onDateChange}
              format="YYYY-MM-DD" showTime={{ defaultValue: moment('00:00:00') }} />
          </Form.Item>
          {studyHour}
          <Form.Item
            label="Тема Занятия"
            name="theme"
            value={theme}
            onChange={onThemeChange}
            rules={[{ required: true, message: 'Введите тему занятия' }]}
          >
             <Input />
          </Form.Item>
          <Form.Item
            label="Домашняя работа"
            name="desc"
            value={desc}
            onChange={onDescChange}
            rules={[
              {
                required: true,
                message: "Введите домашнюю работу",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </PageWrapper>
    );
  }
export default LessonCreatePage;
